import { combineReducers } from "redux";
import manage_wallet from "../features/admin/manage_wallet/Slice";

const ManageWallet = combineReducers({
  manage_wallet: manage_wallet,
});

export default ManageWallet;
